"use client";

import { ThemeProvider } from "@/provider/theme-provider";
import StoreProvider from "@/provider/store-provider";
import { AuthProvider } from "@/context/AuthContext";
import { AppUIProvider } from "@/context/AppUIContext";
import AxiosTokenInitializer from "@/components/AxiosTokenInitializer";
import React from "react";
import { ProgressProvider } from "@bprogress/next/app";

export const AppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <ThemeProvider attribute="class" defaultTheme="light">
      <AuthProvider>
        <AxiosTokenInitializer />
        <AppUIProvider>
          <StoreProvider>
            <ProgressProvider
              height="4px"
              color="var(--primarySystem100)"
              options={{ showSpinner: false }}
              shallowRouting
            >
              {children}
            </ProgressProvider>
          </StoreProvider>
        </AppUIProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};
